import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import Details from "./views/Details";
import Shipments from "./views/Shipments";
import ReturnLines from "./views/ReturnLines";
import PutBackOverview from "./views/PutBackOverview";
import { useCreateReturnMutation } from "../../../../newapi/inbound/returnsSlice";

const MpCreateStandAloneReturn = (props) => {
    const {t} = useTranslation();

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper
                tabAfterSave="tabPutBack"
                query={useCreateReturnMutation}
                isModal
                title={t("create_return")}
            >
                <Details scannedValue={props.scannedValue}/>
                <ReturnLines/>
                <Shipments/>
                <PutBackOverview handleClose={props.handleClose}/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpCreateStandAloneReturn;